<template>
    <main>
        <SliceZone :slices="slices" :components="components" />
    </main>
</template>

<script setup lang="ts">
    import {NavbarMode} from '@navbar-unlogged-types';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData} from '#app';
    import {definePageMeta, useLocale, useWebsitePageView, createError} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {useABTestSlices} from '~/composables/useABTestSlices';
    import {useDefineSeoAndMetaTags} from '~/composables/useDefineSeoAndMetaTags';
    import {components} from '~/slices/components';

    definePageMeta({
        middleware: 'redirect-to-home',
        validate: (): boolean => useFeatureFlag('new-freelancer-homepage').value || useLocale().isMultiLocaleHost.value,
        navbar: NavbarMode.FREELANCER,
    });

    const {fetchDocument} = usePrismicDocument('homeFreelancer');
    const {data, error} = await useAsyncData('homeFreelancer', () => fetchDocument());
    if (error.value) {
        throw createError(error.value);
    }

    const {slices} = useABTestSlices(data.value!);

    useDefineSeoAndMetaTags(data.value!);
    useWebsitePageView('cms', 'freelancer-homepage');
</script>
